import { Reveal } from "./Reveal";
import { Phone, MessageSquare, Truck, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquare,
    title: "We reach out — fast",
    body: "Usually within minutes. You'll hear from Claire on our team by text or call — the same steady voice all the way through.",
  },
  {
    icon: Truck,
    title: "A crew is dispatched",
    body: "We confirm the details and send a crew to extract water and start drying. No waiting on an estimate before anyone acts.",
  },
  {
    icon: ShieldCheck,
    title: "No pressure, no obligation",
    body: "You're not signing up to shop quotes or commit to a renovation. The goal right now is simple: stop the damage and protect your home.",
  },
];

export const WhatHappens = () => {
  return (
    <section data-testid="what-happens-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-mono text-[12px] tracking-[0.22em] uppercase text-erg-ember">
            After you hit submit
          </span>
          <h2 className="mt-4 font-display font-bold uppercase text-erg-ink leading-[0.95] text-[clamp(2rem,6vw,3.75rem)]">
            What actually happens
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full rounded-2xl border border-erg-ink/10 bg-white/55 p-7">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-erg-ember/15 text-erg-ember">
                  <s.icon className="h-5 w-5" strokeWidth={2} />
                </span>
                <h3 className="mt-5 font-display font-semibold text-erg-ink text-2xl leading-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-erg-ink/70 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
